import script from "./MyArticle_setup.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyArticle_setup.vue?vue&type=script&lang=ts&setup=true"

import "./MyArticle_setup.vue?vue&type=style&index=0&id=70ab776b&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ab776b"]])

export default __exports__